import { gsap } from 'gsap';

class HomepageHero {
  constructor(el) {
    this.el = el;

    // grab a reference to the circle and line elements
    const svg = this.el.getElementsByClassName('js-homepage-hero-svg')[0];
    const cir = el.getElementsByClassName('js-homepage-hero-circle')[0];
    const line = el.getElementsByClassName('js-homepage-hero-line')[0];
    const boxes = el.getElementsByClassName('js-homepage-hero-ui');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const pathLength = line.getTotalLength();
    line.style.strokeDasharray = pathLength;
    line.style.strokeDashoffset = -pathLength;

    const tl = gsap.timeline();
    const o = { t: 0 };

    // 0-1 location on the timeline
    function setTime(t) {
      // set the location of the circle
      const p = pathLength * t;
      const pt = line.getPointAtLength(p);
      line.style.strokeDashoffset = pathLength * (1 - t);
      cir.style.webkitTransform = `translate3d(${pt.x}px,${pt.y}px,0)`;
    }

    tl.to(svg, { opacity: 1, duration: 0.1 });
    tl.to(o, { t: 0.99, onUpdate: () => setTime(o.t), duration: reduceMotion ? 0 : 3 });
    tl.fromTo(
      boxes,
      { opacity: 0, translateY: reduceMotion ? '0px' : '-20px', stagger: 0 },
      { opacity: 1, translateY: '0px', stagger: 0.5 },
      '+1',
    );
  }
}

export default HomepageHero;
